(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rpm-predictions"]) return;
  try {
    
  (function () {
    'use strict';
    var root = document.querySelector('[data-rpm-predictions]');
    if (!root) return;
    var source = root.querySelector('[data-rpm-source]');
    var app = root.querySelector('[data-rpm-app]');
    var overallTarget = root.querySelector('[data-rpm-overall]');
    var ffl = root.querySelector('[data-rpm-ffl]');
    var fflTarget = root.querySelector('[data-rpm-ffl-grid]');
    var switcher = root.querySelector('[data-rpm-class-switcher]');
    var lightbox = root.querySelector('[data-rpm-lightbox]');
    var lightboxImage = root.querySelector('[data-rpm-lightbox-image]');
    var lightboxClose = root.querySelector('[data-rpm-lightbox-close]');
    var lastOpener = null;
    var labels = {
      prediction: root.getAttribute('data-label-prediction'),
      ffl: root.getAttribute('data-label-ffl'),
      className: root.getAttribute('data-label-class'),
      open: root.getAttribute('data-label-open'),
      sx: root.getAttribute('data-label-sx'),
      mx: root.getAttribute('data-label-mx'),
      smx: root.getAttribute('data-label-smx'),
      round: root.getAttribute('data-label-round')
    };

    function imageAfter(heading) {
      var node = heading ? heading.nextElementSibling : null;
      while (node && !/^H[234]$/.test(node.tagName)) {
        if (node.tagName === 'IMG') return node;
        var image = node.querySelector ? node.querySelector('img') : null;
        if (image) return image;
        node = node.nextElementSibling;
      }
      return null;
    }

    function classFrom(text) {
      var match = String(text || '').match(/\b(250|450)\b/);
      return match ? match[1] : null;
    }

    function recordFromFigure(figure) {
      var image = figure.querySelector('img');
      if (!image) return null;
      return {
        className: figure.getAttribute('data-class') || classFrom(figure.textContent),
        image: image,
        type: figure.getAttribute('data-type') || (figure.closest('[data-rpm-ffl]') ? 'ffl' : 'overall')
      };
    }

    function collectRecords() {
      var records = [];
      var figures = source.querySelectorAll('[data-rpm-prediction-card]');
      Array.prototype.forEach.call(figures, function (figure) {
        var record = recordFromFigure(figure);
        if (record && record.className) records.push(record);
      });
      if (records.length) return records;
      Array.prototype.forEach.call(source.querySelectorAll('h4'), function (heading) {
        var text = heading.textContent || '';
        var className = classFrom(text);
        var image = imageAfter(heading);
        if (!className || !image) return;
        records.push({ className: className, image: image, type: /FFL|first[- ]lap/i.test(text) ? 'ffl' : 'overall' });
      });
      return records;
    }

    function copyImage(image, alt, eager) {
      var result = document.createElement('img');
      result.src = image.currentSrc || image.src;
      result.alt = image.alt || alt;
      result.loading = eager ? 'eager' : 'lazy';
      result.decoding = 'async';
      return result;
    }

    function card(record, label, eager) {
      var figure = document.createElement('figure');
      figure.className = 'rpm-predictions__prediction-card rpm-predictions__prediction-card--' + record.className;
      figure.setAttribute('data-rpm-class-card', record.className);
      var heading = document.createElement('figcaption');
      heading.className = 'rpm-predictions__card-heading';
      heading.innerHTML = '<span>' + label + '</span><strong>' + record.className + ' ' + labels.className + '</strong>';
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'rpm-predictions__image-button';
      button.setAttribute('aria-label', labels.open + ' ' + record.className + ' ' + labels.className + ' ' + label.toLowerCase());
      var image = copyImage(record.image, record.className + ' ' + labels.className + ' ' + label, eager);
      button.appendChild(image);
      button.addEventListener('click', function () { openLightbox(image.src, image.alt, button); });
      figure.appendChild(heading);
      figure.appendChild(button);
      return figure;
    }

    function findSectionImage(startId, stopId) {
      var heading = source.querySelector(startId);
      var node = heading ? heading.nextElementSibling : null;
      while (node) {
        if (stopId && node.matches && node.matches(stopId)) break;
        if (node.tagName === 'IMG') return node;
        var image = node.querySelector ? node.querySelector('img') : null;
        if (image) return image;
        node = node.nextElementSibling;
      }
      return null;
    }

    function renderMedia(targetSelector, image, alt) {
      var target = root.querySelector(targetSelector);
      if (!target || !image) return;
      target.appendChild(copyImage(image, alt, false));
    }

    function raceMeta(records) {
      if (!records.length) return;
      var context = source.querySelector('[data-rpm-current-round]');
      var series = context ? context.getAttribute('data-series') : '';
      var year = context ? context.getAttribute('data-year') : '';
      var round = context ? context.getAttribute('data-round') : '';
      var temperature = context ? context.getAttribute('data-temperature') : '';
      var condition = context ? context.getAttribute('data-condition') : '';
      var path = records[0].image.src || '';
      var eventMatch = path.match(/(20\d{2})(SX|MX|SMX)[_-]?(?:Round|ROUND)[_ -]?(\d+)/i);
      if (eventMatch) {
        year = year || eventMatch[1];
        series = series || eventMatch[2].toUpperCase();
        round = round || eventMatch[3];
      }
      var weatherMatch = path.match(/[_ -](\d{2,3})F[_ -]([^.?/]+)/i);
      if (weatherMatch) {
        temperature = temperature || weatherMatch[1];
        condition = condition || weatherMatch[2].replace(/[_-]+/g, ' ');
      }
      var eventLabel = series === 'SX' ? labels.sx : series === 'MX' ? labels.mx : series === 'SMX' ? labels.smx : '';
      var eventNode = root.querySelector('[data-rpm-event]');
      var weatherNode = root.querySelector('[data-rpm-weather]');
      if (eventLabel || year || round) eventNode.textContent = [year, eventLabel, round ? labels.round + ' ' + round : ''].filter(Boolean).join(' · ');
      if (temperature || condition) weatherNode.textContent = [temperature ? temperature + '°F' : '', condition].filter(Boolean).join(' · ');
      var meta = root.querySelector('[data-rpm-meta]');
      meta.hidden = !eventNode.textContent && !weatherNode.textContent;
      eventNode.hidden = !eventNode.textContent;
      weatherNode.hidden = !weatherNode.textContent;
    }

    function selectClass(className) {
      overallTarget.setAttribute('data-active-class', className);
      Array.prototype.forEach.call(switcher.querySelectorAll('button'), function (button) {
        button.setAttribute('aria-pressed', button.getAttribute('data-class') === className ? 'true' : 'false');
      });
    }

    function buildSwitcher(records) {
      var classes = [];
      records.forEach(function (record) { if (classes.indexOf(record.className) === -1) classes.push(record.className); });
      classes.sort();
      classes.forEach(function (className) {
        var button = document.createElement('button');
        button.type = 'button';
        button.textContent = className + ' ' + labels.className;
        button.setAttribute('data-class', className);
        button.addEventListener('click', function () {
          var change = function () { selectClass(className); };
          if (document.startViewTransition) document.startViewTransition(change); else change();
        });
        switcher.appendChild(button);
      });
      selectClass(classes.indexOf('450') !== -1 ? '450' : classes[0]);
    }

    function openLightbox(url, alt, opener) {
      if (!url) return;
      lastOpener = opener;
      lightboxImage.src = url;
      lightboxImage.alt = alt || '';
      if (typeof lightbox.showModal === 'function') lightbox.showModal(); else lightbox.setAttribute('open', '');
      document.body.classList.add('prevent-scrolling');
      lightboxClose.focus();
    }

    function closeLightbox() {
      if (typeof lightbox.close === 'function' && lightbox.open) lightbox.close(); else lightbox.removeAttribute('open');
      lightboxImage.removeAttribute('src');
      document.body.classList.remove('prevent-scrolling');
      if (lastOpener) lastOpener.focus();
    }

    function init() {
      var records = collectRecords();
      var overall = records.filter(function (record) { return record.type === 'overall'; });
      var fflRecords = records.filter(function (record) { return record.type === 'ffl'; });
      if (!overall.length) return;
      overall.sort(function (a, b) { return a.className.localeCompare(b.className); });
      overall.forEach(function (record) { overallTarget.appendChild(card(record, labels.prediction, true)); });
      buildSwitcher(overall);
      if (fflRecords.length) {
        fflRecords.sort(function (a, b) { return a.className.localeCompare(b.className); });
        fflRecords.forEach(function (record) { fflTarget.appendChild(card(record, labels.ffl, false)); });
        ffl.hidden = false;
      }
      renderMedia('[data-rpm-how-media]', findSectionImage('#howto', '#factors'), 'How to use RPM predictions');
      renderMedia('[data-rpm-factor-media]', findSectionImage('#factors'), 'RPM model feature importance');
      raceMeta(overall);
      lightboxClose.addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', function (event) { if (event.target === lightbox) closeLightbox(); });
      lightbox.addEventListener('cancel', function (event) { event.preventDefault(); closeLightbox(); });
      source.hidden = true;
      app.hidden = false;
    }

    init();
  }());

  } catch(e) { console.error(e); }
})();
})();
